import './MediaSubscription.sass';

import React, { FC, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router5';

import { Button, Header, Placeholder, ScrollView } from '$uikit';
import { useTranslator } from '$hooks';
import { Loader, SubscriptionIcon } from '$shared/components';
import { rnbr, statReachGoal } from '$utils';
import {
  IcGallery28,
  IcMonetization28,
  IcStar28,
  IcSuccess72,
  IcUser28,
  IcWallet28,
} from '$assets';
import { subscriptionsActions } from '$store/subscriptions';
import { AuthPopoverState, SubscriptionType } from '$store/models';
import { Api } from '$api';
import { toastActions } from '$store/toast';
import { authSelector } from '$store/auth';
import { profileActions } from '$store/profile';
import { FEED } from '$shared/constants/pages';
import { mainSelector } from '$store/main';
import { AuthPopoverSimple } from '$core/AuthPopover/AuthPopover';

import { setSubscriptionContentPriority } from '$utils/subscriptionAuthor';
import { ContentPriorityType } from '$store/main/interface';

export const MediaSubscription: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();

  const { isLogged } = useSelector(authSelector);
  const { decryptKeys } = useSelector(mainSelector);
  const hasSubscription = decryptKeys[-SubscriptionType.Media];

  const [loadingStatus, setLoadingStatus] = useState('loading');
  const [price, setPrice] = useState({ ton: 0, eur: 0 });

  const loadData = useCallback(() => {
    setLoadingStatus('loading');
    setSubscriptionContentPriority(ContentPriorityType.OTHER);
    Api.get(`/balance/subscription/common/media`)
      .then((data: any) => {
        setPrice({
          ton: data.price,
          eur: data.eurPrice,
        });
        setLoadingStatus('loaded');
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
        setLoadingStatus('failed');
      });
  }, []);

  useEffect(() => {
    loadData();
    if (!hasSubscription) {
      statReachGoal('media_paywall');
    }
  }, []);

  const handleSubscription = useCallback(() => {
    if (!isLogged) {
      dispatch(profileActions.setAuthPopoverState(AuthPopoverState.LOGIN));
    }

    dispatch(
      subscriptionsActions.subscriptionDialog({
        price: price.ton,
        categoryId: SubscriptionType.Media,
      }),
    );
    statReachGoal('media_paywall_buy_press');
  }, [price, isLogged]);

  if (hasSubscription) {
    return (
      <Placeholder
        centered
        title={t('subscription_success_title')}
        icon={<IcSuccess72 />}
        actions={
          <Link routeName={FEED}>
            <Button>{t('subscription_success_button_go_to_feed')}</Button>
          </Link>
        }
      >
        {t('subscription_success_media_caption')}
      </Placeholder>
    );
  }

  return <Placeholder title="Media subscription is unavailable" centered />;
  //
  // return (
  //   <div className="MediaSubscription">
  //     <Header showBackButton />
  //     <ScrollView
  //       footer={
  //         <Button onClick={handleSubscription}>{t('subscription_buy_button')}</Button>
  //       }
  //     >
  //       {loadingStatus === 'loading' && <Loader isWrapped />}
  //       {loadingStatus === 'failed' && (
  //         <Placeholder
  //           title={t('failed_title')}
  //           actions={
  //             <Button size="small" onClick={loadData}>
  //               {t('failed_button')}
  //             </Button>
  //           }
  //         >
  //           {t('failed_caption')}
  //         </Placeholder>
  //       )}
  //       {loadingStatus === 'loaded' && (
  //         <>
  //           <SubscriptionIcon type={SubscriptionType.Media} authorId={0} size="large" />
  //           <div className="MediaSubscription__content">
  //             <h1 className="MediaSubscription__title">
  //               {t('media_subscription_title')}
  //             </h1>
  //             <p className="MediaSubscription__description">
  //               {rnbr(t('media_subscription_description'))}
  //             </p>
  //             <div className="MediaSubscription__list">
  //               <div className="MediaSubscription__item">
  //                 <div className="MediaSubscription__item__icon _monetization">
  //                   <IcMonetization28 />
  //                 </div>
  //                 <div className="MediaSubscription__item__title">
  //                   {t('media_subscription_list_item_1_title')}
  //                 </div>
  //                 <div className="MediaSubscription__item__description">
  //                   {t('media_subscription_list_item_1_caption')}
  //                 </div>
  //               </div>
  //               <div className="MediaSubscription__item">
  //                 <div className="MediaSubscription__item__icon _wallet">
  //                   <IcWallet28 />
  //                 </div>
  //                 <div className="MediaSubscription__item__title">
  //                   {t('media_subscription_list_item_staking_title')}
  //                 </div>
  //                 <div className="MediaSubscription__item__description">
  //                   {t('media_subscription_list_item_staking_caption')}
  //                 </div>
  //               </div>
  //               <div className="MediaSubscription__item">
  //                 <div className="MediaSubscription__item__icon _user">
  //                   <IcUser28 />
  //                 </div>
  //                 <div className="MediaSubscription__item__title">
  //                   {t('media_subscription_list_item_2_title')}
  //                 </div>
  //                 <div className="MediaSubscription__item__description">
  //                   {t('media_subscription_list_item_2_caption')}
  //                 </div>
  //               </div>
  //               <div className="MediaSubscription__item">
  //                 <div className="MediaSubscription__item__icon _gallery">
  //                   <IcGallery28 />
  //                 </div>
  //                 <div className="MediaSubscription__item__title">
  //                   {t('media_subscription_list_item_3_title')}
  //                 </div>
  //                 <div className="MediaSubscription__item__description">
  //                   {t('media_subscription_list_item_3_caption')}
  //                 </div>
  //               </div>
  //               <div className="MediaSubscription__item">
  //                 <div className="MediaSubscription__item__icon _star">
  //                   <IcStar28 />
  //                 </div>
  //                 <div className="MediaSubscription__item__title">
  //                   {t('media_subscription_list_item_4_title')}
  //                 </div>
  //                 <div className="MediaSubscription__item__description">
  //                   {t('media_subscription_list_item_4_caption')}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </>
  //       )}
  //     </ScrollView>
  //     <AuthPopoverSimple />
  //   </div>
  // );
};
